export class LoggableError extends Error {
  name: string;
  code?: string;
  statusCode?: number;
  message: string;
  messages?: string[];
  fileName?: string;
  lineNumber?: number;
  url?: string;
  stack = '';

  static create(errorOrMsg: string | LoggableError | Error, rethrowMsg?: string): LoggableError {
    const error = typeof errorOrMsg === 'string' ? new Error(errorOrMsg) : errorOrMsg as Error;

    return new LoggableError(error, rethrowMsg);
  }

  static toJSON(error: LoggableError | Error): LoggableError {
    return merge(error, { name: error.name, message: error.message, stack: error.stack || '' });
  }

  private constructor(error: LoggableError | Error, rethrowMsg?: string) {
    super(rethrowMsg || error.message);

    merge(error, this);

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this);
    } else {
      this.stack = (new Error(this.message)).stack || '';
    }

    const origStack = error.stack || (error as any).stackTrace;

    if (rethrowMsg) {
      const stackLines = this.stack.split('\n');

      const messageLines = (this.message.match(/\n/g) || []).length + 1;
      const topStackLines = [
        ...stackLines.slice(0, messageLines),
        stackLines[messageLines + 2]    // Skip line 1 and 2 since they are LoggableError.create and new LoggableError()
      ];

      this.stack = topStackLines.join('\n') + '\n' + origStack;
    } else {
      this.stack = origStack;
    }
  }
}

function merge(source: LoggableError | Error, target: LoggableError): LoggableError {
  const sourceAny = source as any;
  const sourceLoggable = source as LoggableError;
  const code = sourceLoggable.code || (sourceAny.cause && sourceAny.cause.code);

  target.name = source.name || source.constructor.name;

  if (code) {
    target.code = code;
  }
  if (sourceLoggable.statusCode) {
    target.statusCode = sourceLoggable.statusCode;
  }
  if (sourceLoggable.fileName) {
    target.fileName = sourceLoggable.fileName;
  }
  if (sourceLoggable.lineNumber) {
    target.lineNumber = sourceLoggable.lineNumber;
  }
  if (sourceAny.url) {
    target.url = sourceAny.url;
  }
  if (sourceAny.messages && sourceAny.messages.length) {
    target.messages = [ ...sourceAny.messages ];
  }

  return target;
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/loggable.error.ts